/* eslint-disable */
export const addIcon = {
  data: `<svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.9095 1.93604V23.8409M23.862 12.8885H1.95711" stroke="currentColor" stroke-width="1.93614" stroke-linecap="round"/></svg>`,
  name: 'add' as const,
};
